import { coworldReplayRoute } from "./replay-routes";
import type { CoworldReplayTelemetryContext } from "../frame/replay-telemetry";
import {
  bitWorldReplayViewerUrl,
  normalizeReplayUrl,
  publishedCoworldJsonReplayUrl,
} from "./replay-viewers";

export type ReplayViewerKind = "mettascope" | "bitworld" | "coworld";
type ReplayLinkInput = {
  viewer: ReplayViewerKind;
  replayUrl: string | null | undefined;
  downloadUrl?: string | null | undefined;
  coworldId?: string | null;
  coworldTelemetryContext?: CoworldReplayTelemetryContext | undefined;
  fullPageHref?: string | undefined;
  achievement?: string | null | undefined;
};
type ReplayLinks = Readonly<{
  viewerUrl: string | null;
  downloadHref: string | null;
  openLabel: string;
  command: string | null;
}>;

export function replayLinks({
  viewer,
  replayUrl,
  downloadUrl,
  coworldId,
  coworldTelemetryContext,
  fullPageHref,
  achievement,
}: Readonly<ReplayLinkInput>): ReplayLinks {
  const downloadHref = downloadUrl ?? replayUrl ?? null;

  if (viewer === "bitworld")
    return {
      viewerUrl: bitWorldReplayViewerUrl(replayUrl),
      downloadHref,
      openLabel: "Open Viewer",
      command: null,
    };

  if (viewer === "coworld") {
    const viewerUrl =
      coworldId && replayUrl && coworldTelemetryContext
        ? (fullPageHref ??
          coworldReplayRoute({
            coworldId,
            replayUri: replayUrl,
            telemetryContext: coworldTelemetryContext,
            options: {
              achievement,
            },
          }))
        : null;
    return {
      viewerUrl,
      downloadHref: replayUrl
        ? (downloadUrl ?? publishedCoworldJsonReplayUrl(replayUrl))
        : downloadHref,
      openLabel: "Open Full Page",
      command:
        coworldId && replayUrl
          ? `uv run coworld replay ${coworldId} ${replayUrl}`
          : null,
    };
  }

  return {
    viewerUrl: normalizeReplayUrl(replayUrl),
    downloadHref,
    openLabel: "Open in MettaScope",
    command: null,
  };
}
